
<div>
  <align class="header" flex>
    <h3 class="secondary-font">
      Ladder Headlines
    </h3>

    <icon-link as="router-link" to="/feed?f=Headline">
      View More
    </icon-link>
  </align>

  <!-- eslint-disable-next-line vue/no-v-html -->
  <p v-if="data.mostRecentHeadlines" v-html="data.mostRecentHeadlines.body" />

  <div v-if="data.mostRecentHeadlines" class="grid">
    <card-note
      v-for="(cardNote, i) in data.mostRecentHeadlines.cardNotes"
      :key="i"
      as="router-link"
      :to="`/dashboard?cardId=${cardNote.card}`"
      :card-note="cardNote"
    />
  </div>
</div>
